import React, { useEffect, useState, useRef } from 'react';
import axios from 'axios';
import { Link, useNavigate } from 'react-router-dom';
import Sidebar from './components/Sidebar';
import Header from './components/Header';
import useAppLayout from './hooks/useAppLayout';
import API_URL from './api/config';
import './styles/style.css'; // Custom CSS for slider
import { toast, ToastContainer } from 'react-toastify';
import { useQuery, useQueryClient} from '@tanstack/react-query';
import ReactModal from 'react-modal';
import imageCompression from 'browser-image-compression';

function FamilySettingsEditTotem() {

    const { menu, toggleMobileMenu } = useAppLayout();
    const navigate = useNavigate();
  const queryClient = useQueryClient();

  const loggedFamilyAdmin = localStorage.getItem('family_admin');
  const [totemModalOpen, setTotemModalOpen] = useState(false);
  const [selectedTotemId, setSelectedTotemId] = useState(null);
  const [isUpdating, setIsUpdating] = useState(false); // NEW

  // Fetch totems + family data
  const {
    data: totemData,
    isLoading: isTotemLoading,
    isError: isTotemError,
  } = useQuery({
    queryKey: ['totemSettings'],
    queryFn: () =>
      axios.get(`${API_URL}/totem-settings-api`, { withCredentials: true })
        .then(res => res.data),
    staleTime: 0,
    cacheTime: Infinity,
  });

  const familyData = totemData?.family_data || {};
  const totemList = totemData?.totems || [];

  // Preselect totem whenever data loads
  useEffect(() => {
    if (familyData?.totem_id) {
      setSelectedTotemId(familyData.totem_id);
    }
  }, [familyData]);

  const openModalWithDataTotem = () => {
    setSelectedTotemId(familyData?.totem_id || (totemList[0]?.id ?? null));
    setTotemModalOpen(true);
  };

  const handleUpdateTotem = () => {
    if (!selectedTotemId || isNaN(selectedTotemId)) {
      toast.error('Invalid totem selected.', { position: 'top-right', autoClose: 3000 });
      return;
    }

    setIsUpdating(true); // disable button
    axios.put(`${API_URL}/update-totem-settings-api`, { totem_id: selectedTotemId }, { withCredentials: true })
      .then(() => {
        toast.success('Totem updated successfully', { position: 'top-right', autoClose: 3000 });
        setTotemModalOpen(false);
        queryClient.invalidateQueries(['totemSettings']);
        navigate('/family-settings');
      })
      .catch(err => {
        console.error('Totem update failed:', err.response?.data || err.message);
        toast.error('Update failed. Please try again.', { position: 'top-right', autoClose: 3000 });
      })
      .finally(() => {
        setIsUpdating(false); // re-enable button
      });
  };

  if (isTotemLoading) {
    return (
      <div className='loadingspinnerDiv'>
        <div className='loadingspinner'></div>
      </div>
    );
  }

  if (isTotemError) return <p>Error loading totems.</p>;
   

    return (
            <div className={`main-wrapper ${menu ? 'slide-nav': ''}`}>
            <Header onMenuClick={(value) => toggleMobileMenu()} />
            <Sidebar />

                <div className="page-wrapper">
                    <div className="content container-fluid">

                    <div className="vstack gap-3">


                 <div className='row'>
                              <div className='col-3 col-md-3'>
                                <Link to='/family-settings' style={{ textDecoration: 'none', color: '#184A2C' }}>
                                  <i className='fa fa-arrow-left' style={{ fontSize: '18px' }}></i>
                                </Link>
                              </div>
                            </div>
                
                            <div className='row'>
                            <div className='col-3 col-md-3'>
                                    </div>
                                  <div className='col-6 col-md-6'>
                                <div className='card'>
                                  <div className='card-body'>
                                    <p style={{ fontWeight: '600', textAlign: 'center' }}>Edit Totem</p>
                
                                    {familyData && (
                                      <div className='mt-4 border rounded p-3'>
                                        <p>
                                          <strong>Totem:</strong>{' '}
                                          {totemList.find(t => t.id === familyData?.totem_id)?.totem_name || 'Update Totem'}
                                          {loggedFamilyAdmin === '1' && (
                                            <button onClick={openModalWithDataTotem} style={{ background: 'transparent', border: 'none' }}>
                                              <i className='fas fa-edit' style={{ fontSize: '16px' }}></i>
                                            </button>
                                          )}
                                        </p>
                                      </div>
                                    )}
                                  </div>
                                </div>
                              </div>
                
                              {/* Modal */}
                              <ReactModal isOpen={totemModalOpen} onRequestClose={() => setTotemModalOpen(false)}
                                className='Modal' overlayClassName='Overlay'>
                                <div className='modal-header'>
                                  <h5 className='modal-title'>Edit Totem</h5>
                                  <button type='button' className='btn-close modalCloseButton' onClick={() => setTotemModalOpen(false)}></button>
                                </div>
                
                                <div className='modal-body'>
                                  <label>Totem Name</label>
                                  <select
                  className="form-select"
                  value={selectedTotemId || ''}
                  //onChange={(e) => setSelectedTotemId(parseInt(e.target.value))}
                
                  onChange={(e) => {
                    const value = e.target.value;
                    if (value === "insert_totem") {
                      navigate("/family-settings-edit-totem-add");
                    } else {
                      setSelectedTotemId(parseInt(value));
                    }
                  }}
                >
                  <option value="" >Select a totem</option>
                  {totemList.map(totem => (
                    <option key={totem.id} value={totem.id}>
                      {totem.totem_name}
                    </option>
                  ))}
                  <option value="insert_totem" style={{ fontWeight: "900" }}>
                        Insert your totem
                      </option>
                </select>
                
                                </div>
                
                                <div className='modal-footer'>
                                  <button
                                    className='btn btn-primary'
                                    onClick={handleUpdateTotem}
                                    disabled={isUpdating} // Disable during update
                                  >
                                    {isUpdating ? 'Updating...' : 'Update Totem'}
                                  </button>
                                </div>
                              </ReactModal>
                            </div>


                    </div>
                    </div>
                </div>
            </div>
        
    );
}

export default FamilySettingsEditTotem;
